import { render } from "./EthereumChart.vue?vue&type=template&id=e89c4360&ts=true"
import script from "./EthereumChart.vue?vue&type=script&lang=ts"
export * from "./EthereumChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__